import React from 'react';
import styles from './index.module.scss';

const TitleComponent = ({
  contentData,
  contentText,
  contentName,
  imgName,
  imgsNames,
  videoName,
}) => {
  return (
    <div className={styles.titleComponent}>
      <h2 className={styles.title}>Компонент Заголовка</h2>
      <p className={styles.description}>Компонент для отображения заголовков</p>
      {contentText && contentText !== 'none' && (
        <div className={styles.contentText}>
          <p>{contentText}</p>
        </div>
      )}
    </div>
  );
};

export default TitleComponent;
